import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx, _cache) {
  const _component_NumberSpinner = _resolveComponent("NumberSpinner")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.getClass('form-items__inner'))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.components, (component, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createCommentVNode(" Render Form Item "),
        (component.type=='number_spinner')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(_ctx.getClass('form__item'))
            }, [
              _createVNode(_component_NumberSpinner, {
                component: component,
                messageId: _ctx.messageId
              }, null, 8 /* PROPS */, ["component", "messageId"])
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true)
      ], 64 /* STABLE_FRAGMENT */))
    }), 256 /* UNKEYED_FRAGMENT */))
  ], 2 /* CLASS */))
}